import {type RouteLocationStringParam} from 'vue-router';

const FaqList            = () => import('../views/faq/FaqList.vue');
const FaqEdit            = () => import('../views/faq/FaqEdit.vue');
const CategoryIndex      = () => import('../views/faq/CategoryIndex.vue');
const CategoryExportList = () => import('../views/faq/CategoryExportList.vue');

export const faqBasicBreadcrumb: Breadcrumb = {
    label: 'FAQ - Häufig gestellte Fragen',
    href: {name: 'faq-list'},
};

let meta = {
    layout: 'enhanced',
    module: 'faq',
};

let faq = [
    {
        name: 'faq',
        path: '/faq',
        redirect: {name: 'faq-list'},
        meta,
    },
    {
        name: 'faq-list',
        path: '/faq/list/:categoryId(\\d+)?/:status(s\\d+)?/:filter(flag|mine)?',
        component: FaqList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                categoryId: parseInt(route.params.categoryId as string || '0'),
                status: parseInt((route.params.status as string || '').substr(1) || '-1'),
                filter: route.params.filter || '',
            };
        },
    },
    {
        name: 'faq-view',
        path: '/faq/view/:id(\\d+)',
        alias: [
            '/faq/faq/view/id/:id(\\d+)',
        ],
        component: FaqList,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                faqId: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'faq-edit',
        path: '/faq/edit/:id/:category?',
        component: FaqEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                categoryId: parseInt(route.params.category),
            };
        },
    },
    {
        name: 'category-index',
        path: '/faq/category/index',
        component: CategoryIndex,
        meta,
    },
    {
        name: 'category-export-list',
        path: '/faq/category/export-list',
        component: CategoryExportList,
        meta,
    },
    {
        path: '/faq/:wildcard*',
        redirect: {name: 'faq-list'},
        meta,
    },
    {
        path: '/faq/faq/list/categoryId/:categoryId(\\d+)?/:status(s\\d+)?/:filter(flag|mine)?',
        redirect: {name: 'faq-list'},
    },
];

export default faq;